// Spend dashboard API client (v2 Step 7).
// All endpoints are owner-scoped server-side via Auth0 JWT → user_id.

import { apiGet } from "./client";

export interface SpendBucket {
  bucket: string; // YYYY-MM-DD or YYYY-MM
  tool_calls: number;
  input_tokens: number;
  output_tokens: number;
  total_tokens: number;
  cost_usd: string; // Decimal serialised
  trace_count: number;
}

export interface SpendTotals {
  tool_calls: number;
  total_tokens: number;
  trace_count: number;
  cost_usd: string;
}

export interface SpendResponse {
  granularity: "day" | "month";
  buckets: SpendBucket[];
  totals: SpendTotals;
}

export interface CapStatus {
  used_usd: string;
  cap_usd: string;
  remaining_usd: string;
  ratio: number;
  resets_at: string; // ISO-8601
  exceeded: boolean;
  warn: boolean;
}

export interface SpendTraceRow {
  trace_id: string;
  session_id: string | null;
  route_class: string;
  tool_calls: number;
  total_tokens: number;
  cost_usd: string;
  status: string;
  ended_at: string;
}

export interface SpendTracesResponse {
  day: string;
  traces: SpendTraceRow[];
}

export function fetchSpend(
  granularity: "day" | "month" = "day",
  fromDate?: string,
  toDate?: string,
): Promise<SpendResponse> {
  const params = new URLSearchParams({ granularity });
  if (fromDate) params.set("from", fromDate);
  if (toDate) params.set("to", toDate);
  return apiGet<SpendResponse>(`/spend/me?${params.toString()}`);
}

export function fetchCapStatus(): Promise<CapStatus> {
  return apiGet<CapStatus>("/spend/me/cap");
}

export function fetchTracesForDay(day: string): Promise<SpendTracesResponse> {
  const params = new URLSearchParams({ day });
  return apiGet<SpendTracesResponse>(`/spend/me/traces?${params.toString()}`);
}
